import "./create/nlgPermissionGroupCreate"
import "./create/PermissionGroupCreateParams"
import "./details/permissionGroupDetailsController"
import "./details/permissionGroupDetailsService"
import "./select/nlgPermissionGroupSelect"
import "./administration/permissionGroupAdministrationController"
import "./support/permissionGroupSupportController"
import "./support/permissionGroupSupportService"
import "./microstrategy-configuration"
import "./externalfreight-configuration"